<template>
  <hit_login>

    <hit_dashboard>

      <div class="hit-container">

        <div class="hit-alert hit-alert-danger" v-if="!unread_chats">
          {{ $tc("message.noEntry", 1) }}
        </div>

        <div class="hit-row" v-else>
          <div class="hit-col-md-4">
            <div class="hit-list-group">
              <a href="#" class="hit-list-group-item hit-html-a" v-for="(chat, index) in unread_chats" v-on:click.prevent="get_entry_data(chat.settings, index)">
                {{ $t("message.unreadChats") }} <b>#{{ index + 1 }}</b>
              </a>
            </div>
          </div>

          <div class="hit-col-md-8">
            <transition name="fade">
            <div class="hit-panel hit-panel-primary" v-if="entry" v-bind:key="get_key()">
              <div class="hit-panel-body" >
                <entryInfo :entry="entry" :settings="{view: 'full'}" />
                <div class="hit-text-right">
                <router-link v-html="$t('message.goTo', {name: $tc('message.feedback', 1)+' '+entry.name})" class="hit-html-a" :to="{ name:'feedback_details', params: {lang: $store.getters.lang, entryID: unread_chats[ID].settings.ID, boardID: unread_chats[ID].settings.board} }"></router-link>
              </div>
              </div>
              <div class="hit-panel-heading">
                {{ $t("message.userChat") }}
              </div>
              <div class="hit-panel-body">
                <compontent class="hit-html-html" :is="'feedback_chat'" :entry="entry" :settings="Object.assign(unread_chats[ID].settings, {user: $store.getters.user.md5_id})"/>
              </div>
            </div>
          </transition>
          </div>

        </div>
      </div>

    </hit_dashboard>
  </hit_login>

</template>

<script>

import feedback_chat from '@core/components/content/app/feedback/feedback_chat'
import entryInfo from '@core/components/content/app/feedback/feedback_entry_info'

export default{
  components: {feedback_chat, entryInfo},
  data () {
    return {
      ID: false,
      open: false,
      unread_chats: false,
      entry: false
    }
  },
  methods: {

    get_key () {
      return this.open
    },

    get_entry_data (settings, open) {
      var my_class = this

      this.ID = open

      if (typeof this.$store.getters.user.md5_id === 'undefined') { return false }

      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: this.$store.getters.user.md5_id, board: settings.board, ID: settings.ID},
        callback: function (ret) {
          if (ret.data[0]) {
            my_class.entry = ret.data[1]
            my_class.open = settings.board + settings.ID
          }
        }})
    },
    get_chat_messages: function () {
      var my_class = this

      if (typeof my_class.$store.getters.unread_chats === 'object') {
        my_class.unread_chats = my_class.$store.getters.unread_chatnr
        return false
      }

      this.$store.dispatch('get_unread_chats', function () {
        my_class.unread_chats = my_class.$store.getters.unread_chatnr
      })
    }

  },
  created () {
    this.get_chat_messages()
  }
}

</script>
